const initialState = {
  refCampaign: {
    campaigns: [],
    pageNumber: 0,
    totalCount: undefined,
    pageSize: 100,
    campaignDetail: null,
  },
  dataSet: {
    dataSets: [],
    pageNumber: 0,
    totalCount: undefined,
    pageSize: 100,
  },
  pilotageVolume: {
    pilotageVolumes: [],
    pageNumber: 0,
    totalCount: undefined,
    pageSize: 100,
  },
  outgoingTarget: {
    outgoingTarget: [],
    pageNumber: 0,
    totalCount: undefined,
  },
  error: {
    code: undefined,
    message: undefined,
    enabled: false,
    reconnectingTrays: 0,
  },
  retries: { retries: 0 },
  account: {
    refreshToken: undefined,
    expirationTime: undefined,
    accessToken: undefined,
    expirationDate: undefined,
    roles: undefined,
    username: undefined,
    email: undefined,
  },
};
export default initialState;
